import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function TestimonialsSection() {
  return <section className="bg-white px-4 py-7 md:px-12" data-id="element-163" data-mp="20qnlbiupm5lf">
      <h2 className="mx-auto max-w-xl text-center text-xl font-extrabold uppercase leading-tight tracking-tight text-blue-950 md:text-3xl" data-id="element-164" data-mp="1n0tz78al9zfe">
        Experiencias de electricistas que utilizan el sistema
      </h2>
      <p className="mt-1.5 text-center text-sm font-bold uppercase text-sky-600" data-id="element-165" data-mp="1d0t9n4m4mn2r">Opiniones de profesionales</p>
      <div className="mt-4 space-y-2.5" data-id="element-166" data-mp="1i1qvpsa9c19j">
        {testimonials.map(t => <figure key={t.name} className="rounded-md border border-slate-200 bg-slate-50 px-3.5 py-3" data-id="element-167" data-mp="141y1vo3fp4xc">
            <div className="flex items-center justify-between gap-2" data-id="element-168" data-mp="183t3ktpa1kbn">
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-169" data-mp="2yfh0705agrjp">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" aria-hidden data-id="element-170" data-mp="32fhp5eq0kl50" data-mpi={i} />)}
              </div>
              <span className="text-xs font-bold uppercase text-sky-600" data-id="element-171" data-mp="2uz80vljmmp6k">{t.topic}</span>
            </div>
            <blockquote className="mt-1.5 text-sm leading-snug text-slate-600 md:text-base" data-id="element-172" data-mp="34re1tkruwgxw">“{t.quote}”</blockquote>
            <figcaption className="mt-2" data-id="element-173" data-mp="2zrrdaf6kve9s">
              <span className="block text-xs font-extrabold uppercase text-blue-950" data-id="element-174" data-mp="2zst01gwyhp7c">
                {t.name}, {t.age} años
              </span>
              <span className="block text-xs leading-snug text-slate-600" data-id="element-175" data-mp="273vixh4hdyg6">{t.role}</span>
            </figcaption>
          </figure>)}
      </div>
    </section>;
}